import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import providerHandler from '../../utils/provider-handler';
import handleLogin from '../../utils/handle-login';
import { LOGIN_MUTATION } from '../../mutations';
import getApiCredentialsSetting from '../../utils/get-api-credentials-setting';

const Login = ({ onLogin, onError, errorMsg, error, settings }) => {
  const [doLoginMutation, { client }] = useMutation(LOGIN_MUTATION, {
    update: async (cache, { data }) => {
      if (!(await handleLogin(data, client))) return null;

      return onLogin();
    },
    onError: e => onError(e),
    context: { credentials: getApiCredentialsSetting() }
  });

  const authProviders = providerHandler.getInOrder();

  if (!authProviders) return null;

  return (
    <div className="auth-login-provider-wrapper">
      {authProviders.map(({ key, LoginComponent }) => {
        if (!LoginComponent) return null;

        const providerLogin = variables =>
          doLoginMutation({ variables: providerHandler.getProviderLoginVariables(key, variables) });
        return (
          <div key={key} className={`auth-login-provider--${key}`}>
            <LoginComponent
              onLogin={providerLogin}
              errorMsg={errorMsg}
              settings={settings}
              error={error}
            />
          </div>
        );
      })}
    </div>
  );
};

Login.propTypes = {
  onLogin: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  errorMsg: PropTypes.string,
  settings: PropTypes.object,
  error: PropTypes.object
};

Login.defaultProps = {
  errorMsg: '',
  settings: {},
  error: null
};

export default Login;
